import { IncidentLogNotificationAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

// The template editor preview shows every field so the whole template can be reviewed, even the ones that would
// stay hidden until the notification question is answered. After a yes the date is shown and the description explains
// how the notification was given; after a not yet or not required it holds the reason it was not given instead.
export function isNotificationGiven(answer: IncidentLogNotificationAnswer | null | undefined, isPreview: boolean) {
    return isPreview || answer === IncidentLogNotificationAnswer.Yes;
}

export function showsNotificationDescription(answer: IncidentLogNotificationAnswer | null | undefined, isPreview: boolean) {
    return isPreview || (answer !== null && answer !== undefined);
}

// Switching between not yet and not required keeps the description, as both explain why the notification was not given.
export function changesNotificationDescriptionMeaning(
    previousAnswer: IncidentLogNotificationAnswer | null | undefined,
    nextAnswer: IncidentLogNotificationAnswer
) {
    return isNotificationGiven(previousAnswer, false) !== isNotificationGiven(nextAnswer, false);
}
